import { configureStore } from "@reduxjs/toolkit";
import { loadBrowserState, saveBrowserState } from "./browser-store";
import authReducer, { ESliceAuth } from "./slices/authSlice";
import menuReducer, { ESliceMenu } from "./slices/menuSlice";
import metaEnv from "../helper/metaEnv";

import logger from "redux-logger";

const preloadedState = loadBrowserState();

export const store = configureStore({
    preloadedState,
    reducer: {
        [ESliceAuth.AuthInfo]: authReducer,
        [ESliceMenu.menu]: menuReducer
    },
    middleware: (getDefaultMiddleware) => {
        if (metaEnv.reduxLogger) {
            return getDefaultMiddleware({ thunk: false }).concat(logger);
        } else {
            return getDefaultMiddleware({ thunk: false });
        }
    }
});

const currentAuthInfo = {
    access_token: "",
    refresh_token: ""
};

store.subscribe(() => {
    const allState = store.getState();

    const stateTargetToSave: { [key: string]: any } = {};
    let isStateChanged = false;

    if (
        allState[ESliceAuth.AuthInfo].access_token !== currentAuthInfo.access_token ||
        allState[ESliceAuth.AuthInfo].refresh_token !== currentAuthInfo.refresh_token
    ) {
        // state change
        // set new current auth
        currentAuthInfo.access_token = allState[ESliceAuth.AuthInfo].access_token;
        currentAuthInfo.refresh_token = allState[ESliceAuth.AuthInfo].refresh_token;

        isStateChanged = true;
    }

    // handle value for localstorage
    if (currentAuthInfo.access_token && currentAuthInfo.refresh_token) stateTargetToSave[ESliceAuth.AuthInfo] = { ...currentAuthInfo };

    isStateChanged && saveBrowserState(stateTargetToSave);
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
